import React from "react";
import { Public as PublicRoutes } from "../routes";

export default () => <PublicRoutes />;
